import React from 'react';
import { bool, shape, string } from 'prop-types';

const Lock = ({
  className = 'icon',
  notUseClass = false,
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={style} width="1em" height="1em" viewBox="0 0 18 18" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M12.75 6.375H13.5C14.325 6.375 15 7.05 15 7.875V15.375C15 16.2 14.325 16.875 13.5 16.875H4.5C3.675 16.875 3 16.2 3 15.375V7.875C3 7.05 3.675 6.375 4.5 6.375H5.25V4.875C5.25 2.805 6.93 1.125 9 1.125C11.07 1.125 12.75 2.805 12.75 4.875V6.375ZM9 2.625C7.755 2.625 6.75 3.63 6.75 4.875V6.375H11.25V4.875C11.25 3.63 10.245 2.625 9 2.625ZM4.5 15.375V7.875H13.5V15.375H4.5ZM10.5 11.625C10.5 12.45 9.825 13.125 9 13.125C8.175 13.125 7.5 12.45 7.5 11.625C7.5 10.8 8.175 10.125 9 10.125C9.825 10.125 10.5 10.8 10.5 11.625Z" fill="currentColor" />
  </svg>
);

Lock.propTypes = {
  className: string,
  notUseClass: bool,
  style: shape({}),
};

export default Lock;
